import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import App from './app/App.tsx';
import { getLogger } from './lib/logger/logger';
import './styles/globals.css';
import './i18n'; // Initialize i18n
import './styles/header.css';
import { exposeVersionHelpers, logAppVersion } from './shared/utils/version';

const logger = getLogger('app:sw');

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Expose console helper and log version (dev mode only)
if (import.meta.env.DEV) {
  exposeVersionHelpers();
}
void logAppVersion();

// ✅ P2-1: Service Worker 등록 (프로덕션 환경 전용)
if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then(registration => {
          logger.debug('[SW] Service Worker registered:', registration.scope);
        })
        .catch(error => {
          logger.error('[SW] Service Worker registration failed:', error);
        });
    });
  } else {
    // 개발 환경에서는 기존 SW/캐시를 정리해서 Vite 리소스 캐싱 충돌을 방지한다.
    window.addEventListener('load', () => {
      void navigator.serviceWorker
        .getRegistrations()
        .then(registrations => Promise.all(registrations.map(registration => registration.unregister())))
        .then(results => {
          if (results.some(Boolean)) {
            logger.info('[SW] Cleared existing service workers for development mode');
          }
        })
        .catch(error => {
          logger.warn('[SW] Failed to clear service workers in development mode:', error);
        });

      if ('caches' in window) {
        void caches
          .keys()
          .then(cacheNames => Promise.all(cacheNames.map(cacheName => caches.delete(cacheName))))
          .catch(error => {
            logger.warn('[SW] Failed to clear caches in development mode:', error);
          });
      }
    });
  }
}
